import { Checkbox, TableCell, TableRow } from "@mui/material";
import React, { useState } from "react";
import moment from "moment";

const AdminsTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleNavigateToDetails,
  columnWidths,
}) => {
  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff", height: 30 }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        scope="row"
        padding="none"
        onClick={handleNavigateToDetails}
        style={{
          ...tableTitleFieldStyles,
          width: columnWidths?.firstName || 170,
          minWidth: columnWidths?.firstName || 170,
          maxWidth: columnWidths?.firstName || 170,
        }}
      >
        {row.firstName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.lastName || 140,
          minWidth: columnWidths?.lastName || 140,
          maxWidth: columnWidths?.lastName || 140,
        }}
      >
        {row.lastName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.userName || 140,
          minWidth: columnWidths?.userName || 140,
          maxWidth: columnWidths?.userName || 140,
        }}
      >
        {row.userName}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdAt || 140,
          minWidth: columnWidths?.createdAt || 140,
          maxWidth: columnWidths?.createdAt || 140,
        }}
      >
        {row?.createdAt &&
          moment.unix(row?.createdAt?.seconds).format("MM-DD-YYYY")}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          textTransform: "capitalize",
          width: columnWidths?.status || 140,
          minWidth: columnWidths?.status || 140,
          maxWidth: columnWidths?.status || 140,
        }}
      >
        {row.status}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          textTransform: "capitalize",
          width: columnWidths?.role || 140,
          minWidth: columnWidths?.role || 140,
          maxWidth: columnWidths?.role || 140,
        }}
      >
        {row.role}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.lastLoginDate || 170,
          minWidth: columnWidths?.lastLoginDate || 170,
          maxWidth: columnWidths?.lastLoginDate || 170,
        }}
      >
        {row?.lastLoginDate &&
          moment.unix(row?.lastLoginDate?.seconds).format("MM-DD-YYYY")}
      </TableCell>
    </TableRow>
  );
};

export default AdminsTableRow;

const tableTitleFieldStyles = {
  // paddingLeft: 5,
  // fontWeight: 600,
  border: "1px solid #BABABA",
  color: "#00A7CD",
  fontFamily: "Avenir Book, sans-serif",
  height: 30,
  paddingLeft: 10,
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  height: 30,
  paddingLeft: 10,
};
// const tableStatusCellStyles = {
//   border: "1px solid #BABABA",
//   cursor: "pointer",
//   fontWeight: 600,
// };
